import { detectOSAndBrowser } from "@smart/itops-utils-basic";

type UserAgentDataNavigator = Navigator & {
  userAgentData?: {
    brands?: { brand: string; version: string }[];
    mobile?: boolean;
    platform?: string;
  };
};

const isNoiseUserAgentBrand = (brand: string): boolean => {
  const b = brand.trim();
  if (/^Chromium$/i.test(b)) return true;
  return /^Not[\s);:._~-]*A?[\s);:._~-]*Brand$/i.test(b);
};

const browserFromUserAgentDataBrands = (
  brands: { brand: string; version: string }[] | undefined,
): string | undefined => {
  if (!brands?.length) return undefined;
  const meaningful = brands.filter(
    (entry) => !isNoiseUserAgentBrand(entry.brand),
  );
  const pick = meaningful[0];
  if (!pick) return undefined;
  const label = pick.brand.trim();
  const version = pick.version.trim();
  if (!label) return undefined;
  return version ? `${label} ${version}` : label;
};

const deviceTypeFromNavigator = (ua: string, mobile?: boolean): string => {
  if (mobile) return "mobile";
  const maxTouch =
    typeof navigator !== "undefined" ? (navigator.maxTouchPoints ?? 0) : 0;
  const isIpadOs =
    typeof navigator !== "undefined" &&
    navigator.platform === "MacIntel" &&
    maxTouch > 1;
  if (/iPad|Tablet|PlayBook|Silk/i.test(ua) || isIpadOs) return "tablet";
  if (/Mobi|Android.*Mobile|iPhone|iPod|IEMobile|Opera Mini/i.test(ua))
    return "mobile";
  return "desktop";
};

export const collectSignatureContext = () => {
  if (typeof navigator === "undefined") return {};

  const nav = navigator as UserAgentDataNavigator;
  const ua = navigator.userAgent;
  const { userAgentData } = nav;

  const browserFromBrands = browserFromUserAgentDataBrands(
    userAgentData?.brands,
  );

  return {
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    signedAt: new Date().toISOString(),
    browser: browserFromBrands ?? detectOSAndBrowser(ua).browser,
    os: userAgentData?.platform || detectOSAndBrowser(ua).os,
    deviceType: deviceTypeFromNavigator(ua, userAgentData?.mobile),
  };
};
